<template>
  <a-layout>
    <a-card :bordered="false">
      <a-form ref="ruleForm" :model="backForm" :label-col="{span:2}" :wrapper-col="{span:10}" :scrollToFirstError="true">

        <a-form-item ref="members" label="会员" name="members" required>
          <a-button type="primary" @click="chooseUser">
            <PlusOutlined />
            添加会员
          </a-button>
          <a-table v-if="data.length" :pagination='false' borderedr :columns='columns' :data-source='data' class="tableFixBox">
            <template v-slot:action="{ index }">
              <a-button type="primary" @click='del(index)'>删除</a-button>
            </template>
          </a-table>
        </a-form-item>
        <a-form-item ref="blacklist_type" label="有效期"  required>
          <a-radio-group name="radioGroup" v-model:value="backForm.blacklist_type">
            <a-radio :value="0">永久拉黑</a-radio>
            <a-radio :value="1">限时拉黑</a-radio>
          </a-radio-group>
          <div v-if="backForm.blacklist_type==1">
            限时:
            <a-input-number v-model:value="backForm.blacklist_limit" /> <span style="color:#666">小时,(到期后自动释放,恢复扫码参与活动功能)</span>
          </div>
        </a-form-item>
        <a-form-item ref="remarks" label="原因" name="remarks" required>
          <a-textarea v-model:value="backForm.remarks" allow-clear />
        </a-form-item>
        <a-form-item :wrapper-col="{offset:2}">
          <a-button type="primary" @click="submit" :loading="loading">
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择会员" centered v-model:visible="userVisible" :footer="null" width="1200px">
    <selectUser checkout v-on:select="selectHandle" :selectList="data" v-if="userVisible" />
  </a-modal>
</template>
<script>
import { inject, ref } from "vue";
import { message } from "ant-design-vue";
import { createBlacklists } from "@/api/qrcode";
import { iscode } from "../../../utils/app";
export default {
  setup() {
    const backForm = ref({
      members: [],
      blacklist_type: 0,
      blacklist_limit: "",
      remarks: "",
    });
    const columns = [
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
      },
      {
        title: "会员ID",
        dataIndex: "member_id",
        key: "member_id",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const data = ref([]);
    // 选择会员
    const userVisible = ref(false);
    const chooseUser = () => {
      userVisible.value = true;
    };
    const selectHandle = (userData) => {
      var list = data.value;
      data.value = userData
      userVisible.value = false;
    };
    const del = (index) => {
      data.value.splice(index, 1);
    };
    const loading = ref(false);
    const router = inject("$router");
    const submit = async () => {
      if (!data.value.length) {
        message.error("请选择会员");
        return;
      }
      if (
        backForm.value.blacklist_type == 1 &&
        !backForm.value.blacklist_limit
      ) {
        message.error("请输入限时时间");
        return;
      }
      if (!backForm.value.remarks) {
        message.error("请输入原因");
        return;
      }
      backForm.value.members = [];
      loading.value = true;
      data.value.map((v) => backForm.value.members.push(v.member_id));
      let result = await createBlacklists(backForm.value)
        .then((res) => res.data)
        .catch((error) => error);
      loading.value = false;
      if (iscode(result, true)) {
        router.go(-1);
      }
    };
    return {
      backForm,
      data,
      columns,
      chooseUser,
      userVisible,
      selectHandle,
      del,
      submit,
      loading,
    };
  },
};
</script>